import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type { CouponCreateDto, CouponDto, CouponFilterParams, CouponUpdateDto, CouponValidateDto, CouponValidateResponseDto } from "@/types/coupon.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const couponsService = {
  getAll(filter: CouponFilterParams = { pageSize: 50 }): Promise<PagedResponseDto<CouponDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<CouponDto>>>("/Coupons", { params: filter }),
    );
  },

  getById(id: number): Promise<CouponDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CouponDto>>(`/Coupons/${id}`));
  },

  validate(dto: CouponValidateDto): Promise<CouponValidateResponseDto> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<CouponValidateResponseDto>>("/Coupons/validate", dto)
    );
  },

  create(dto: CouponCreateDto): Promise<CouponDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<CouponDto>>("/Coupons", dto));
  },

  update(id: number, dto: CouponUpdateDto): Promise<CouponDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<CouponDto>>(`/Coupons/${id}`, dto));
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.delete<ApiResponse<boolean>>(`/Coupons/${id}`));
  },
};
